import { UiTourType } from '@booking-booster-client/models';
import { statisticsCampaignsSteps } from './steps';

export const StatisticsCampaignsTour: UiTourType = {
  slug: 'statistics-campaigns',
  steps: statisticsCampaignsSteps,
  nextStep: 'ads',
  viewingRequired: true,
};
